/**
 * @generated SignedSource<<f567895aadbe7f8b1d30709e9c475a0e>>
 * @relayHash a4dd0c5be1663f90e5d0685708221148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 505d092e7c0d41f6265f966da6c27d5fee5ef75761ae3944457163e71824dad0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { DeferEditionModalComponentQuery } from './DeferEditionModalComponentQuery.graphql';

const node: PreloadableConcreteRequest<DeferEditionModalComponentQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "505d092e7c0d41f6265f966da6c27d5fee5ef75761ae3944457163e71824dad0",
    "metadata": {},
    "name": "DeferEditionModalComponentQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
